import React, { useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
const columns = [
  { id: "id", label: "ID", cellCss: { minWidth: 50 }, getValue: (r) => r.id },
  {
    id: "title",
    label: "Title",
    cellCss: { minWidth: 150 },
    getValue: (r) => r.title,
  },
  {
    id: "description",
    label: "Description",
    cellCss: { minWidth: 120 },
    getValue: (r) => r.description,
  },
  { id: "order", label: "Order", minWidth: 100, getValue: (r) => r.order },
  {
    id: "qaCount",
    label: "QA Count",

    getValue: (r) => r.qaCount,
  },
  //   {
  //     id: "subTitle",
  //     label: "Sub Title",
  //     getValue: (r) => r.subTitle,
  //   },
  //   { id: "unitId", label: "Unit Id", getValue: (r) => r.unitId },
  //   {
  //     id: "unitName",
  //     label: "Unit Name",
  //     getValue: (r) => r.unitName,
  //   },
  {
    id: "locked",
    label: "Locked",
    align: "right",
    getValue: (r) => (r.locked ? "Yes" : "No"),
  },
];

function EssayQA({ EssayQA, setBookContent }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [deletionId, setDeletionId] = useState(null);
  const [showDependencyModal, setShowDependencyModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  console.log(EssayQA);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Delete confirmation dialog box
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // Onclick delete icon delete id store in state and open delete dialog box.
  const handleClickOpen = (id) => {
    setDeletionId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // Delection after click confrim delete the
  const handleDelete = async () => {
    if (!deletionId) return;
    try {
      //  Await the API call to handle errors properly
      await api.delete(`/api/v1/bookUnits/${deletionId}`);

      setBookContent((prev) => {
        if (!prev) return prev;
        const qa = prev["Question And Answers"] ?? {};
        const topicWise = qa["Essay Questions and Answers"] ?? [];

        const updatedList = topicWise.filter(
          (item) => item.id !== Number(deletionId)
        );
        console.log("updateList", updatedList);

        return {
          ...prev,
          "Question And Answers": {
            ...qa,
            "Essay Questions and Answers": updatedList,
          },
        };
      });
      setOpen(false);
      setDeletionId(null);
      setTimeout(() => {
        toast.success("Successfully deleted Essay Questions and Answers!", {
          autoClose: 2000,
        });
      }, 0);
    } catch (error) {
      console.error("Failed to delete record:", error);

      if (error.response && error.response.status === 424) {
        toast.error(
          "Cannot delete Book unit Without deleting Book unit details",
          {
            autoClose: 3000,
          }
        );
        setShowDependencyModal(true);
        setOpen(false);
      } else {
        toast.error("An unexpected error occurred while deleting.", {
          autoClose: 3000,
        });
      }
    } finally {
      setIsDeleting(false);
    }
  };
  // Delete the Book unit Details code
  const handleDepandencyDelete = async () => {
    try {
      console.log(deletionId);
      // Await the API call to handle errors properly
      await api.delete(`/api/v1/bookUnitDetails/${deletionId}`);
      setShowDependencyModal(false);
      setDeletionId(null);

      toast.success(
        "Successfully deleted Essay Questions and Answers Unit deatils!",
        {
          autoClose: 2000,
        }
      );
    } catch (error) {
      console.error("Failed to delete record:", error);
    }
  };
  return (
    <>
      <Paper sx={{ width: "100%", overflow: "auto" }}>
        <TableContainer sx={{ maxHeight: "70vh" }}>
          <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sx={{
                      align: "left",
                      backgroundColor: "#17479e",
                      color: "#ffffff",
                      position: "sticky",
                      top: 0,
                      zIndex: 3,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  sx={{
                    align: "left",
                    backgroundColor: "#17479e",
                    color: "#ffffff",
                    position: "sticky",
                    top: 0,
                    right: 0,
                    zIndex: 4,
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {EssayQA.length > 0 ? (
                EssayQA.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((r, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={r.id}>
                    {columns.map((column) => {
                      const value = column.getValue
                        ? column.getValue(r)
                        : r[column.id];
                      return (
                        <>
                          <TableCell
                            key={column.id}
                            sx={{
                              ...r.cellCss,
                            }}
                            align={"left"}
                          >
                            {value}
                          </TableCell>
                        </>
                      );
                    })}
                    <TableCell
                      sx={{
                        align: "left",
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      <DeleteIcon
                        sx={{
                          color: "#d50000",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClickOpen(r.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={EssayQA.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Confirm Delete Units?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want delete these records? <br />
            This process cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelPresentationIcon
            onClick={handleClose}
            sx={{
              fontSize: "40px",
              cursor: "pointer",
              color: "red",
              marginBottom: "20px",
            }}
          />
          <CheckBoxIcon
            onClick={handleDelete}
            sx={{
              fontSize: "40px",
              color: "green",
              marginRight: "10px",
              marginBottom: "20px",
              cursor: "pointer",
            }}
            autoFocus
          />
        </DialogActions>
      </Dialog>
      <Dialog
        open={showDependencyModal}
        onClose={() => setShowDependencyModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Deletion of Unit Details First ?</DialogTitle>
        <DialogContent>
          <p>
            This unit is linked to unit details and cannot be deleted directly.
          </p>
          <p>Please delete the associated unit details first.</p>
          <p>
            Click the "
            <CheckBoxIcon
              sx={{
                color: "green",
                cursor: "pointer",
              }}
              autoFocus
            />
            " button below to delete the unit details.
          </p>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            <CancelPresentationIcon
              onClick={() => setShowDependencyModal(false)}
              sx={{
                fontSize: "40px",
                cursor: "pointer",
                color: "red",
                marginBottom: "20px",
              }}
            />
            <CheckBoxIcon
              onClick={handleDepandencyDelete}
              sx={{
                fontSize: "40px",
                color: "green",
                marginRight: "10px",
                marginBottom: "20px",
                cursor: "pointer",
              }}
              autoFocus
            />
          </DialogActions>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EssayQA;
